import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Classes from '../../../common/Classes';
import {faCaretDown, faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Dropdown from 'react-bootstrap-latest/Dropdown';
import {trackMixpanelEvent} from '../../../common/MixpanelHelper';
import mixpanelConstants from '../../../common/mixpanelConstants';

const Stand = props => {
    const standReference = props.standReference.split(', ');
    const containerRef = useRef();
    const iconRef = useRef();
    const standRef = useRef();
    const [dropdownItems, setDropdownItems] = useState([]);
    const standRefs = standReference.map(() => React.createRef());
    useEffect(() => {
        if (containerRef.current) {
            let totalWidth = 0;
            let containerWidth = containerRef.current.offsetWidth
            if (window.innerWidth >= 1199) {
                containerWidth = containerWidth * 2;
            }
            let overflowItems = [];

            standRefs.forEach((ref, i) => {
                totalWidth += ref.current.offsetWidth;
                if (totalWidth > containerWidth) {
                    overflowItems.push(standReference[i]);
                }
            });

            setDropdownItems(overflowItems);
        }
    }, [window.innerWidth]);

    function getStandRef(stand, index) {
        return <>
            {stand}{index < standReference.length - 1 && !dropdownItems.includes(standReference[index + 1]) ? ',' : ''}
        </>;
    }

    const handleTrackMixpanelEvent = () => {
        trackMixpanelEvent(mixpanelConstants.eventName.exhibitorClicked, {...props.mixpanelProps});
    };


    return (
        <div className={Classes.standContent}>
          <div className={Classes.directoryStand} ref={containerRef}>
              <span ref={iconRef}>
                    <FontAwesomeIcon icon={faMapMarkerAlt}/>
              </span>
              <span ref={standRef}> {props.translations.stand}</span>
              {standReference.map((stand, index) => (
                  !dropdownItems.includes(stand) && (
                      <span key={index} ref={standRefs[index]}>
                          {getStandRef(stand, index)}
                        </span>
                  )
              ))}
              {dropdownItems.length > 0 && (
                  <Dropdown
                    autoClose="outside" 
                    className={Classes.overflowStandDropdown}
                    onClick={handleTrackMixpanelEvent}
                  >
                  <Dropdown.Toggle
                    data-testid="more-stand-toggle"
                    variant="primary"
                    data-dtm={props.dtmTags}
                    data-dtm-attributes={JSON.stringify({ exhibitorId: props.exhibitorId })}
                    >
                      <span>{props.translations.moreStands}</span>
                      <FontAwesomeIcon icon={faCaretDown} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className={Classes.moreStands}>
                    {dropdownItems.map((item, index) => (
                      <Dropdown.Item href="#" key={index}>{item}</Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}
          </div>
      </div>
  )
}

Stand.propTypes = {
    standReference: PropTypes.string.isRequired,
    translations: PropTypes.shape({
        stand: PropTypes.string.isRequired
    }),
    dtmTags: PropTypes.string.isRequired,
    exhibitorId: PropTypes.string.isRequired,
    mixpanelProps: PropTypes.object
};

export default Stand;
